export default "__VITE_ASSET__rZkPN526__"